// Манипуляция фондовым рынком (deus_manipulyatsiya_fondovym_rynkom, action, epic) — без цели.
// Сжигает всё текущее Влияние моего Героя (становится 0).
// Вражескому Герою наносится урон = сожжённое значение (не pierce, броня поглощает).
// Если Влияние было 0 — карта тратится впустую.
// Бонус (xlsx): следующий ход не позволяет получать Влияние.

import { applyHeroDamage, redirectToSekretar } from '../../hero-damage.js';
import { setInfluence } from './influence.js';
import { applyDamage } from '../../combat.js';
import { shortHeroName } from '../../../data/heroes.js';
import { onUnitLeftField, dispatchUnitDied } from './hooks.js';

export const CARD_ID = 'deus_manipulyatsiya_fondovym_rynkom';

export function resolveManipulyatsiya(state, playerIdx) {
  const p = state.players[playerIdx];
  const enemy = state.players[1 - playerIdx];
  const burned = p.influence;
  if (burned === 0) {
    state.log.add(`📉 ${p.name}: Манипуляция фондовым рынком — Влияние было 0, эффект не применён`);
    return { ok: true, burned: 0 };
  }
  setInfluence(state, playerIdx, 0);
  // Блокировка Влияния на ход (текущий ход — после Ф5 не имеет значения, но семантически).
  p.blockInfluenceUntilTurn = state.currentTurn;
  state.log.add(`📉 ${p.name}: Манипуляция — Влияние ${burned}→0, удар по Герою [${enemy.name}]: ${burned} урона`);
  // Перенаправление на Секретаря.
  const { target, redirectedToSekretar } = redirectToSekretar(enemy, enemy.hero);
  if (redirectedToSekretar) {
    const before = { hp: target.hp, armor: target.armor };
    const r = applyDamage(target, burned, { pierce: false });
    state.log.add(`↪ Перенаправлено на Секретаря [${enemy.name}]: ${burned} урона (HP ${before.hp}→${target.hp}, броня ${before.armor}→${target.armor})`);
    if (target.hp <= 0) {
      enemy.removeFromField(target);
      state.log.add(`✗ ${target.name_ru} [${enemy.name}] погибает`);
      dispatchUnitDied(state, { ownerIdx: enemy.id, card: target, killer: null, killerIdx: playerIdx, killerWasCounter: false });
    }
  } else {
    const r = applyHeroDamage(state, 1 - playerIdx, burned, { pierce: false });
    if (!r.immune && !r.parachute) {
      state.log.add(`📉 ${shortHeroName(enemy.hero)} [${enemy.name}]: HP ${enemy.hero.hp + (r.hpLost || 0)}→${enemy.hero.hp}, броня ${enemy.hero.armor + (r.armorAbsorbed || 0)}→${enemy.hero.armor}`);
    }
  }
  return { ok: true, burned };
}
